export const ONBOARDING_GOAL_SELECTED = 'Onboarding: Goal Selected';
export const ONBOARDING_LANGUAGE_SELECTED = 'Onboarding: Language Selected';
export const ONBOARDING_LOGIN_CLICKED = 'Onboarding: Login Clicked';
export const ONBOARDING_OTP_REQUESTED = 'Onboarding: OTP Requested';
export const ONBOARDING_OTP_SUBMITTED = 'Onboarding: OTP Submitted';
export const ONBOARDING_LOGIN_SUCCESSFUL = 'Onboarding: Login Successful';

// checkout
export const CHECKOUT_SUBSCRIPTION_TYPE_SELECTED =
  'Checkout: Subscription Type Selected';
export const CHECKOUT_DURATION_SELECTED = 'Checkout: Duration Selected';
export const CHECKOUT_REFERRAL_CODE_APPLIED = 'Checkout: Referral Code Applied';
export const CHECKOUT_PROCEED_TO_PAYMENT_SELECTED =
  'Checkout: Proceed To Payment Selected';
export const CHECKOUT_CREDITS_REDEEMED = 'Checkout: Credits Redeemed';
export const CHECKOUT_CHANGE_DURATION = 'Checkout: Change Duration';
export const CHECKOUT_PIP_SELECTED = 'Checkout: PIP: Pay In Parts Selected';
export const CHECKOUT_PIP_FAQS_CLICKED =
  'Checkout: PIP: Part Payment FAQs Clicked';
export const CHECKOUT_PIP_NO_OF_PARTS_SELECTED =
  'Checkout: PIP: Number Of Parts Selected';
export const CHECKOUT_ORDER_CREATED = 'Checkout: Order Created';
export const CHECKOUT_STARTED = 'Checkout: Started';

// Login
export const LOGIN_STARTED = 'Login: Started';
export const LOGIN_OTP_REQUESTED = 'Login: OTP Requested';
export const LOGIN_OTP_SUBMITTED = 'Login: OTP Submitted';
export const LOGIN_SUCCESSFUL = 'Login: Successful';

export const GTM_TAP_ENROLL = 'GTM: Tap Enroll';

// LeadGen Form
export const LEADGEN_K12_BOOK_CLICKED = 'LeadGen K12: Book Clicked';
export const LEADGEN_K12_REGISTERED = 'LeadGen K12: Registered';

// TTU
export const TTU_FAB_CLICK = 'TTU - FAB Icon Clicked';
export const TTU_POP_UP_CLICK = 'TTU - Talk to Unacademy Clicked';
export const TTU_CALL_CONFIRM = 'TTU - Call Confirmed';
export const TTU_ANSWER_QUESTIONS = 'TTU - Questions Answered';

// Goal Level Onboarding
export const LEARNING_PREFERENCES_STARTED = 'Learning Preferences - Started';
export const LEARNING_PREFERENCES_QUESTION = 'Learning Preferences - Question';
export const LEARNING_PREFERENCES_ONBOARDING_COMPLETED =
  'Learning Preferences - Onboarding Completed';
export const LEARNING_PREFERENCES_VIEWED = 'Learning Preferences - Viewed';

// Course Related Events
export const COURSE_ENROLLED = 'Course Enrolled';
export const COURSE_UNENROLLED = 'Course Unenrolled';
export const COURSE_VIEWED = 'Course Viewed';
export const COURSE_SHARED = 'Course Shared';
export const COURSE_ABOUT = 'Course About';
export const COURSE_UPDATES = 'Course Updates';
export const COURSE_PREVIEW = 'Course Video Preview';
export const COURSE_UPDATES_FILE_DOWNLOAD = 'Course Updates File Download';

// Test Series Related Events
export const TEST_SERIES_VIEWED = 'Test Series Viewed';
export const TEST_SERIES_SHARED = 'Test Series Shared';
export const TEST_SERIES_ABOUT = 'Test Series About';
export const TEST_SERIES_UPDATES = 'Test Series Updates';
export const TEST_SERIES_ENROLLED = 'Test Series Enrolled';
export const TEST_SERIES_UNENROLLED = 'Test Series Unenrolled';
export const TEST_SERIES_UPDATES_FILE_DOWNLOAD =
  'Test Series Updates File Download';

// Pitch assist related events
export const PA_GOAL_EDITED = 'PA - Goal Edited';
export const PA_FAV_EDU_CLICKED = 'PA - Favourite Educator Clicked';
export const PA_CALL_LIST_CLICKED = 'PA - For Your Call List Clicked';
export const PA_RECOMMENDED_TAB_CLICKED =
  'PA - Recommended Content Tab Clicked';
export const PA_RECOMMENDED_TYPE_CHANGED =
  'PA - Recommended Content Type Changed';
export const PA_EDU_SECTION_CLICKED = 'PA - Educator Section Clicked';
export const PA_CONTENT_CARD_CLICKED = 'PA - Content Card Clicked';
export const PA_PRICING_OPTION_VIEW = 'PA - Pricing Options Viewed';
export const PA_GOAL_PRICING_DETAILS = 'PA - Goal Pricing Details';
export const PA_AVL_PAYMENT_OPTIONS_SELECTED =
  'PA - Available Payments Options Selected';
export const PA_SUB_TYPE_SELECTED = 'PA - Subscription Type Selected';
export const PA_SUB_DURATION_SELECTED = 'PA - Subscription Duration Selected';
export const PA_PAYMENT_LINK_GENERATED = 'PA - Payment Link Generated';
export const PA_LINK_COPIED = 'PA - Link Copied';
export const PA_PAGE_LOAD = 'PA - Page Loaded';

// Batch Related events
export const BATCH_UNENROLLED = 'Batch Unenrolled';
export const BATCH_ENROLLED = 'Batch Enrolled';
export const BATCH_VIEWED = 'Batch Viewed';
export const BATCH_UPDATE = 'Batch Updates';
export const BATCH_SHARED = 'Batch Shared';
export const BATCH_ABOUT = 'Batch About';
export const BATCH_SCHEDULE = 'Batch Schedule Viewed';
export const BATCH_PREVIEW = 'Batch Video Preview';
export const BATCH_SYLLABUS_VIEWED = 'Batch Syllabus Viewed';
export const BATCH_UPDATE_FILE_DOWNLOAD = 'Batch Updates File Download';

// Educator Related Events
export const EDUCATOR_PROFILE_VIEWED = 'Educator Profile Viewed';
export const EDUCATOR_FOLLOWED = 'Educator Followed';
export const EDUCATOR_UNFOLLOWED = 'Educator Unfollowed';
export const EDUCATOR_LEADERBOARD_VIEWED = 'Educator Leaderboard Viewed';
export const EDUCATOR_ABOUT = 'Educator About';
export const EDUCATOR_HATS_VIEWED = 'Educator Hats Viewed';

// Syllabus Events
export const SYLLABUS_CARD_CLICKED = 'Syllabus Card Clicked';
export const SYLLABUS_TAB_CLICKED = 'Syllabus Tab Clicked';

// FEEDBACK EVENTS
export const PLUS_HOME_FEEDBACK_SUBMITTED = 'Plus Subscription Rating';

// Goal Keys
export const GOAL_KEYS = [
  'goal_uid',
  'goal_name',
  'learner_uid',
  'learner_username',
  'language',
  'os',
  'os_version',
  'app_version',
  'platform',
  'browser',
  'is_invited',
  'is_verified',
  'is_subscription_active',
  'days_since_joining',
  'subscription_duration',
  'subscription_end_date'
];

// Syllabus related keys
export const SYLLABUS_CLICKED_KEYS = [
  'goal_uid',
  'goal_name',
  'learner_uid',
  'learner_username',
  'language',
  'os',
  'os_version',
  'app_version',
  'platform',
  'browser',
  'is_invited',
  'is_verified',
  'is_subscription_active',
  'days_since_joining',
  'subscription_duration',
  'subscription_end_date',
  'topology_id',
  'topology_level',
  'topology_name'
];

// Educatore Related Keys

export const EDUCATOR_KEYS = [
  'goal_uid',
  'goal_name',
  'learner_uid',
  'learner_username',
  'language',
  'os',
  'os_version',
  'app_version',
  'platform',
  'browser',
  'is_invited',
  'is_verified',
  'is_subscription_active',
  'days_since_joining',
  'subscription_duration',
  'subscription_end_date',
  'educator_uid',
  'educator_username',
  'last_primary_source',
  'last_primary_source_section',
  'path'
];

// Batch event related keys

export const BATCH_KEYS = [
  'goal_uid',
  'goal_name',
  'learner_uid',
  'learner_username',
  'language',
  'os',
  'os_version',
  'app_version',
  'platform',
  'browser',
  'is_enrolled',
  'is_invited',
  'is_verified',
  'is_subscription_active',
  'days_since_joining',
  'subscription_duration',
  'subscription_end_date',
  'educator_uid',
  'educator_username',
  'last_primary_source',
  'last_primary_source_section',
  'path',
  'batch_uid',
  'batch_title',
  'start_date',
  'end_date'
];

// Course event related keys
export const COURSE_KEYS = [
  'goal_uid',
  'goal_name',
  'learner_uid',
  'learner_username',
  'language',
  'os',
  'os_version',
  'app_version',
  'platform',
  'browser',
  'is_invited',
  'is_verified',
  'is_subscription_active',
  'days_since_joining',
  'subscription_duration',
  'subscription_end_date',
  'educator_uid',
  'educator_username',
  'last_primary_source',
  'last_primary_source_section',
  'path',
  'course_uid',
  'course_title',
  'start_date',
  'end_date',
  'is_enrolled'
];

// Test Series Event Related Keys
export const TEST_SERIES_KEYS = [
  'goal_uid',
  'goal_name',
  'learner_uid',
  'learner_username',
  'language',
  'os',
  'os_version',
  'app_version',
  'platform',
  'browser',
  'is_invited',
  'is_verified',
  'is_enrolled',
  'is_subscription_active',
  'days_since_joining',
  'subscription_duration',
  'subscription_end_date',
  'educator_uid',
  'educator_username',
  'last_primary_source',
  'last_primary_source_section',
  'path',
  'test_series_uid',
  'test_series_title',
  'start_date',
  'end_date'
];

// Referral LPSS Props
export const REFERRAL_PLUS_HOME = 'Plus Home Tab';
export const REFERRAL_MY_SCHEDULE = 'Schedule Tab';
export const REFERRAL_NOTIFICATIONS = 'Updates Tab';
export const REFERRAL_PLAYER_DIALOG = 'Refer & earn Bottomsheet';

// Referral Events
export const REFERRAL_TOUCHPOINT_LOADED = 'Refer - Impression';
export const REFERRAL_CODE_COPIED = 'Refer - Code Copied';
export const REFERRAL_KNOW_MORE = 'Refer - Know More';
export const REFERRAL_LIST_VIEW = 'Refer - Referred Users Viewed';
export const REFERRAL_PLAYER_POPUP = 'Refer - Bottom Sheet Displayed';
export const REFERRAL_TOUCHPOINT_CLICKED = 'Refer - Clicked';
export const REFERRAL_TOUCHPOINT_CLOSED = 'Refer - Card Closed';

export const CLX_LESSON_VIEW = 'CLX - Lesson View';
export const CLX_SUCESSFULL_VIEW_FIVE_MINUTES = 'CLX - Successful View 5 Mins';
export const CLX_SUCESSFULL_VIEW_FIFTEEN_MINUTES =
  'CLX - Successful View 15 Mins';
export const CLX_CLASS_FEEDBACK_SUBMITTED = 'CLX - Class Feedback Submitted';
export const CLX_LESSON_PDF_DOWNLOADED = 'CLX - Lesson PDF Downloaded';
export const PDF_DOWNLOAD = 'CLX - Lesson PDF Downloaded';

// Test Events
export const START_TEST_CLICKED = 'Test - Start Test Clicked';
export const TEST_STARTED = 'Test - Test Started';
export const TEST_FINISHED = 'Test - Test Finished';
export const PERFORMANCE_REPORT_VIEWED = 'Test - Performance Report Viewed';
export const SOLUTION_VIEWED = 'Test - Solutions Viewed';
export const QUESTION_SOLUTION_VIEWED = 'Test - Question Solution Viewed';
export const LEADERBOARD_VIEWED = 'Test - Leaderboard Viewed';

// Save feature events
export const SAVE_SAVE_CONTENT = 'Save - Save Content';
export const SAVE_UNSAVE_CONTENT = 'Save - Unsave Content';
export const SAVE_SAVE_VIEWED = 'Save - Save Viewed';
export const SAVE_FOLDER_VIEWED = 'Save - Folder Viewed';

// Practice session
export const PRACTICE_SECTION_CLICKED = 'Practice - Practice Section Clicked';
export const PRACTICE_SYLLABUS_CHOSEN = 'Practice - Syllabus Chosen';
export const PRACTICE_STARTED = 'Practice - Practice Started';
export const PRACTICE_FINISHED = 'Practice - Practice Finished';
export const PRACTICE_SUMMARY_VIEWED = 'Practice - Summary Viewed';
export const PRACTICE_QUESTION_REVIEW_SUBMITTED =
  'Practice - Question Review Submitted';
export const PRACTICE_QUESTION_REVIEW_REASON_SUBMITTED =
  'Practice - Question Review Reason Submitted';
export const PRACTICE_QUESTION_SKIP_REASON = 'Practice - Question Skip Reason';

// Combat
export const COMBAT_LEARN_MORE = 'Combat - Product Learn More';
export const COMBAT_WEB_ENROLL = 'Combat - Web Enroll Touchpoint';
export const COMBAT_ENROLLED = 'Combat - Enrolled';
export const COMBAT_DEAILS_VIEWED = 'Combat - Details Viewed';
